import { Card, CardContent, Typography } from '@mui/material';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { FaEye } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumbs';
import Notification from '../../components/Notification/Notification';
import Table from '../../components/Table';
import api from '../../services/api';

const classes = {
    root: {
        flexGrow: 1,
        margin: 20,
        marginTop: 30,
        borderRadius: '17px',
        backgroundColor: '#F5F5F5',
        boxShadow: 'none',
    },
    textTitle: {
        margin: 8,
        color: '#103168',
        fontWeight: 600,
        marginBottom: 30,
    },
    message: {
        padding: 10,
        backgroundColor: '#FFFBE8',
        color: 'rgba(0,0,0,0.8)',
        borderRadius: 7,
        width: '100%'
    },
}

const priorityLabels = {
    NORMAL: 'Normal',
    URGENT: 'Urgente',
    EMERGENCY: 'Emergencial',
};

const statusLabels = {
    OPEN: 'Aberta',
    IN_PROGRESS: 'Em Andamento',
    COMPLETED: 'Concluída',
};

const zoneLabels = {
    URBAN: 'Urbana',
    RURAL: 'Rural',
};

export default function MyServiceOrders() {

    const navigate = useNavigate();

    const [notify, setNotify] = useState({ isOpen: false, message: '', type: '', title: '' });
    const [serviceOrders, setServiceOrders] = useState([]);

    useEffect(() => {
        api.get('/service-orders/mine')
            .then(response => {
                setServiceOrders(response.data);
            })
            .catch(err => {
                setNotify({
                    isOpen: true,
                    message: 'Erro ao carregar as ocorrências internas, tente novamente.',
                    type: 'error',
                    title: 'Erro'
                });
            });
    }, []);

    /* Colunas da tabela */
    const columns = useMemo(
        () => [
            {
                Header: 'Nº da Ordem',
                accessor: 'orderNumber',
            },
            {
                Header: 'Data de Emissão',
                id: 'issuedAt', // It needs an ID
                Cell: ({ row }) => (
                    <span>
                        {row.original.issuedAt
                            ? moment(row.original.issuedAt).format('DD/MM/YYYY')
                            : '-'}
                    </span>
                ),
            },
            {
                Header: 'Prioridade',
                id: 'priority', // It needs an ID
                Cell: ({ row }) => (
                    <span>{priorityLabels[row.original.priority] ?? '-'}</span>
                ),
            },
            {
                Header: 'Status',
                id: 'status', // It needs an ID
                Cell: ({ row }) => (
                    <span>{statusLabels[row.original.status] ?? '-'}</span>
                ),
            },
            {
                Header: 'Bairro / Localidade',
                id: 'neighborhood', // It needs an ID
                Cell: ({ row }) => (
                    <span>{row.original.location?.neighborhood || '-'}</span>
                ),
            },
            {
                Header: 'Zona',
                id: 'zone', // It needs an ID
                Cell: ({ row }) => (
                    <span>{zoneLabels[row.original.location?.zone] ?? '-'}</span>
                ),
            },
            {
                // Make an expander cell
                Header: () => null, // No header
                id: 'details', // It needs an ID
                Cell: ({ row }) => (
                    <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => navigate(`/service-order/${row.original.id}`, {
                            state: {
                                isOwner: true,
                                from: [
                                    { name: 'Ocorrências Internas', href: '/my-service-orders' },
                                    { name: 'Minhas Ocorrências Internas', href: '/my-service-orders' },
                                ]
                            }
                        })}
                    >
                        <FaEye
                            size={20}
                            color="#1351B4"
                        />
                    </div>
                ),
            },
        ], [navigate]
    );

    return (
        <>
            <div style={{ marginTop: 32, marginLeft: 20 }}>
                <Breadcrumb
                    paths={[
                        { href: '/my-service-orders', name: 'Ocorrências Internas' },
                        { href: '', name: 'Minhas Ocorrências Internas' },
                    ]}
                />
            </div>

            <Card style={classes.root}>
                <CardContent id='service-orders-list'>

                    <Typography variant="h5" align="center" style={classes.textTitle}>
                        Minhas Ocorrências Internas
                    </Typography>

                    <div style={classes.message}>
                        Consulte a listagem das ocorrências internas cadastradas por você. Na parte
                        direita de cada linha é possível visualizar todas as informações da ocorrência.
                    </div>

                    <Table
                        searchBy='orderNumber'
                        columns={columns}
                        data={serviceOrders}
                        label='Pesquisa pelo nº da ordem de serviço'
                    />

                    <Notification
                        notify={notify}
                        setNotify={setNotify}
                    />

                </CardContent>

            </Card >
        </>
    );
}
